import { stringFieldSchema } from '@utils';

export const PROVIDER_OPTIONS_ERROR = {
  required: {
    path: 'provider-option-required',
    message: 'Select the provider of the EV charging point.',
  },
};

export const SELECT_OPTIONS_ERROR = {
  required: {
    path: 'selection-required',
    message: 'Select an answer to continue.',
  },
};

export const SELECT_WANT_EMAIL_ERROR = stringFieldSchema(
  'SELECT_WANT_EMAIL_ERROR',
  'Select an answer to continue.',
);
